import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService, SettingsService } from 'src/app/core/services';
import { ApplicationService } from 'src/app/core/services/application.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
import { environment } from 'src/environment';
@Component({
  selector: 'app-operators-list',
  templateUrl: './operators-list.component.html',
  styleUrls: ['./operators-list.component.scss', './operators-list.component.scss']
})
export class OperatorsListComponent implements OnInit {
  headText: string;
  operatorsList
  operators;
  subHeadText: string;
  selectedOperator;
  telcoContries: any;
  skinName = environment.skinName;
  constructor(private route: ActivatedRoute, public configService: ConfigurationService,public settingsService: SettingsService,
  private baseService:BaseService, public applicationService:ApplicationService, private router: Router, private analyticsService: InhouseAnalyticsService) {
    this.selectedOperator = this.configService.localeKeys?.["operator.select_region.text"];
  }

  ngOnInit(): void {
    const eventObj = {
      event_type: 'Page View',
      event_name: 'Operators List View',
      event_status: 'Success',
    };
    this.analyticsService.trackUserActions(eventObj);

    this.telcoContries = this.applicationService.telcoContries;
    if (!this.telcoContries.some(country => country.country_name === this.configService.localeKeys?.["operator.all_regions.text"])) {
      this.telcoContries.unshift({
        country_name:(this.configService.localeKeys?.["operator.all_regions.text"])?this.configService.localeKeys?.["operator.all_regions.text"]:"All Regions"});
    }
    this.headText = this.configService.localeKeys?.["operator.select_your_partners.text"];
    this.subHeadText = this.configService.localeKeys?.["operator.select_your_operator.text"];
    let data = this.route.snapshot.data.data;
    this.operatorsList = data.operators_page[0].operators.widget.content;
    this.operators = this.operatorsList;
    this.baseService.telcoSlug = '';
  }
  
  //Telco Operator Login (notion.so)
  operatorRedirect(operator) {
    if(operator.integration_type === "api") this.router.navigate(['auth/signin'],{queryParams:{'operator':operator.slug}});
    else this.router.navigate(['/index/operators', operator.slug]);
  }

  operatorChange(reg) {
    this.operators = this.operatorsList;
    if(reg.country_name == this.configService.localeKeys?.["operator.all_regions.text"] ||reg.country_name == "All Regions" ){
      this.selectedOperator = (this.configService.localeKeys?.["operator.all_regions.text"])?this.configService.localeKeys?.["operator.all_regions.text"]: "All Regions";
      return;
    }
    this.selectedOperator = (this.configService.localeKeys?.[reg.country_name]) ? this.configService.localeKeys?.[reg.country_name] : reg.country_name;
    this.operators = this.operators.filter((oper) => {
      return oper.countries && oper.countries.includes(reg.iso);
    });
  }
  
  eazyProxyLogin(): void {
    window.location.href = environment.ezProxyUrl;
  }
}
